// @ts-nocheck
import { initialState } from "@store/Framework/Store/Bunzl/Pages/Reporting/ReportOrderFrequency/ReportOrderFrequencyReducer";
import useInvoiceSummaryState from "@store/Framework/Store/Bunzl/Pages/Reporting/StoreHooks/useInvoiceSummaryState";
import useOrderFrequencyState from "@store/Framework/Store/Bunzl/Pages/Reporting/StoreHooks/useOrderFrequencyState";
import { usePoError } from "@store/Framework/Store/Bunzl/Pages/Reporting/StoreHooks/usePoError";
import useUpdateReportSearchFields from "@store/Framework/Store/Bunzl/Pages/Reporting/StoreHooks/useUpdateSearchFields";
import { useValidationError } from "@store/Framework/Store/Bunzl/Pages/Reporting/StoreHooks/useValidationError";

const useClear = () => {
    const updateReportSearchFields = useUpdateReportSearchFields();
    const [, setOrderFrequencyState] = useOrderFrequencyState();
    const [, setValidationError] = useValidationError();
    const [, setPoError] = usePoError();
    const [, setInvoiceSummary] = useInvoiceSummaryState();

    return () => {
        updateReportSearchFields(initialState.getReportParams);
        setValidationError(false);
        setPoError(false);
        setInvoiceSummary(undefined);
        setOrderFrequencyState({
            items: [],
            customerCount: 0,
            orderCount: 0,
            uri: "",
            properties: {},
        });
    };
};

export default useClear;
